<style lang='scss' scoped>
table td:first-child {
  width: 50%;
}

table td:nth-child(3),
table th:nth-child(3) {
  padding-right: 10px;
}

.table-overflow {
  overflow: auto;
}
.btn-compound {
  
  .btn-compound-item {
    padding: 0 8px;
  }

  .btn-compound-item:nth-child(2) {
    border: none;
  }

  .btn-compound-item:last-child {
    border-left: 1px solid #efefef;
  }
}


@media only screen and (max-width: 1290px) {
  .title.micro {
    display: block;
    line-height: 1.5em;
  }

  .btn-compound {
    display: flex;
    flex-flow: column-reverse;
    text-align: center;
    width: 80%;

    .btn-compound-item {
      padding: 0;
    }
  }
}

@media only screen and (max-width: 992px) {
  table.responsive-table {
    .th-item {
      margin-bottom: 4rem;
    }

    .th-price {
      margin-bottom: 1rem;
    }
  }

  .btn-compound {
    flex-flow: row;

    .btn-compound-item {
      padding: 0 8px;
    }
  }
}
</style>
<template lang='pug'>
.pt-2.table-overflow
  p.title.small Cart items
  table.responsive-table
    thead
      tr
        th.th-item
          span.subtitle.micro Item
        th.right-align.th-price
          span.subtitle.micro Price
        th.center-align
          span.subtitle.micro Quantity
        th
    tbody
      tr(v-for='(item, index) in $store.state.cart.items')
        td
          span.title.micro {{ item.name }}&nbsp;&nbsp;
          span.subtitle.micro ({{ item.variantCode.toUpperCase() }})
          br
          span.subtitle.micro sold by {{ item.supplier.name }}
          br
          span.subtitle.micro
            i.material-icons.tiny date_range
            | &nbsp;&nbsp;{{ getDeliverySchedule(item) }}
        td.right-align.micro {{ $utils.formatter.formatAmount(item.price) }}
        td.right-align
          .btn-compound.bordered.width100
            a.btn-compound-item.waves-effect(
              @click='addToCart(index, -1)',
              :class='{ disabled: item.quantity < 2 }'
            )
              i.material-icons remove
            span.btn-compound-item {{ item.quantity }}
            a.btn-compound-item.waves-effect(@click='addToCart(index)')
              i.material-icons add
        td.center-align
          //- a.hide-on-med-and-down
          //-   i.material-icons.tiny(
          //-     color='#b03236',
          //-     title='Remove from cart',
          //-     @click='removeFromCart(index)'
          //-   ) remove_circle
          //- a.btn.width100.red.hide-on-large-only(@click='removeFromCart(index)') Remove
          v-icon.hide-on-med-and-down(
            color='#b03236',
            title='Remove from cart',
            @click='removeFromCart(index)'
          ) remove_circle
          v-btn.hide-on-large-only.white-text(
            color='#b03236',
            @click='removeFromCart(index)'
          ) Remove
</template>
<script>
import dateformat from 'dateformat'

export default {
  data() {
    return {}
  },
  computed: {
    items() {
      let items = []
      const itemIds = Object.keys(this.$store.state.cart.items)
      itemIds.forEach((id) => {
        items.push(this.$store.state.cart.items[id])
      })
      return items
    },
  },
  watch: {},
  mounted() {},
  methods: {
    getDeliverySchedule(item) {
      if (item.options) {
        let deliverySchedule
        item.options.some((option) => {
          if (option.type === 'delivery:schedule') {
            if (option.value === 'same_day') {
              deliverySchedule = 'For today'
            } else if (option.value.startsWith('range')) {
              deliverySchedule =
                option.value.split(':')[1].replace(';', ' - ') +
                ' business days'
            } else if (option.value.startsWith('scheduled')) {
              deliverySchedule = dateformat(
                option.value.split(':')[1],
                'ddd, mmm dd'
              )
            }
            return true
          }
        })
        return deliverySchedule
      }
    },
    removeFromCart(index) {
      this.$store.dispatch('cart/removeFromCart', { index: index })
    },
    addToCart(index, quantity) {
      this.$store.dispatch('cart/addToCart', {
        index: index,
        quantity: quantity,
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/page-cart-items.vue